import ankurImg from "@/assets/images/ankur.png";
import KimberlyImg from "@/assets/images/kimbley.svg";
import StackImage1 from "@/assets/images/stackimg1.png";
import StackImage2 from "@/assets/images/stackimg2.png";
import StackImage3 from "@/assets/images/stackimg3.png";
import StackImage4 from "@/assets/images/stackimg4.png";
import StackImage5 from "@/assets/images/stackimg5.png";
import StackImageUSA1 from "@/assets/images/stackimgusa1.jpg";
import StackImageUSA2 from "@/assets/images/stackimgusa2.jpg";
import StackImageUSA3 from "@/assets/images/stackimgusa3.jpg";
import StackImageUSA4 from "@/assets/images/stackimgusa4.jpg";
import StackImageUSA5 from "@/assets/images/stackimgusa5.jpg";
import { SignupRightPanelData } from "@/components/templates/SignupPage/SignupPageLayout";

const IN_AVATARS = [StackImage1, StackImage2, StackImage3, StackImage4, StackImage5];
const US_AVATARS = [StackImageUSA1, StackImageUSA2, StackImageUSA3, StackImageUSA4, StackImageUSA5];

export const signupRightPanelData_IN: SignupRightPanelData = {
  headingPrefix: "The Smartest Creators Don't Work Harder - ",
  headingHighlight: "They Use AI",
  subheading: "Join 2,00,000+ creators using Graphy to",
  bulletPoints: [
    "Go live with a website that sells for you",
    "AI that closes sales & answers students 24/7",
    "Grow to 10x revenue without a single new hire",
  ],
  trustedAvatars: IN_AVATARS,
  testimonial: {
    avatarUrl: ankurImg,
    quote:
      "Graphy is a truly all-in-one platform that covers every aspect of scaling my business seamlessly.",
    name: "Ankur Warikoo",
    badge: "6.93M subscribers",
    badgeIcon: "youtube",
  },
};

export const signupRightPanelData_US: SignupRightPanelData = {
  headingPrefix: "The Smartest Creators Don't Work Harder - ",
  headingHighlight: "They Use AI",
  subheading: "Join 2,00,000+ creators using Graphy to",
  bulletPoints: [
    "Go live with a website that sells for you",
    "AI that closes sales & answers students 24/7",
    "Grow to 10x revenue without a single new hire",
  ],
  trustedAvatars: US_AVATARS,
  testimonial: {
    avatarUrl: KimberlyImg,
    quote:
      "Y'all, I'm obsessed with how Graphy puts people first! As someone who runs both webinars and a monthly bootcamp, I'm continually blown away by how their team goes above and beyond with support for every creator.",
    name: "Kimberly Clark",
    badge: "6k followers",
    badgeIcon: "linkedin",
  },
};